import React from 'react';
import ReactTooltip from 'react-tooltip';

import TooltipIcon from '../images/tooltip-icon.svg';
const defaultStyles = {
	display: 'block',
	width: '100%',
	lineHeight: '1.25em',
	verticalAlign: 'text-top',
};
export const TooltipComponent = (props) => {
	const styles = props.style || {};
	const id = props.id || 'default-tooltip';
	return (
		<span {...props} style={{ ...defaultStyles, styles }}>
			<span
				className="tooltip-icon"
				data-for={id}
				data-tip={props.children || ''}
				data-html={props.type === 'html'}
			>
				<img src={TooltipIcon} style={{ verticalAlign: 'baseline' }} />
			</span>
			<ReactTooltip
				id={id}
				place="bottom"
				type="light"
				effect="solid"
				className="tooltip --table"
			/>
		</span>
	);
};
